import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

export default function LoyaltyTeaser() {
  return (
    <section className="py-16 bg-card">
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10">
        <div className="rounded-2xl gradient-primary p-8 md:p-12 flex flex-col md:flex-row items-center gap-8">
          <div className="flex-1">
            <div className="inline-flex items-center gap-2 bg-accent/20 border border-accent/30 rounded-full px-3 py-1 mb-4">
              <Icon name="StarIcon" size={14} variant="solid" className="text-accent" />
              <span className="text-accent text-xs font-semibold tracking-wide uppercase">Loyalty Programme</span>
            </div>
            <h2 className="text-3xl font-bold text-white mb-3">Play More. Earn More.</h2>
            <p className="text-white/70 text-base leading-relaxed mb-6 max-w-lg">
              Every round you play earns you points toward exclusive rewards — complimentary breakfasts,
              cart hire vouchers, and beverage credits. Play 10 Monday rounds and claim your reward.
            </p>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-8">
              {[
                { label: '47 Active Members', icon: 'UsersIcon' },
                { label: 'Monday Rewards', icon: 'TrophyIcon' },
                { label: 'Winter Challenges', icon: 'FireIcon' },
              ].map((item) => (
                <div key={`loyalty-${item.label}`} className="flex items-center gap-2">
                  <Icon name={item.icon as Parameters<typeof Icon>[0]['name']} size={16} variant="outline" className="text-accent shrink-0" />
                  <span className="text-white/80 text-sm font-medium">{item.label}</span>
                </div>
              ))}
            </div>
            <Link href="/visitor-registration-sign-up-login" className="btn-gold px-6 py-3 rounded-xl text-sm font-bold inline-flex items-center gap-2">
              <Icon name="UserPlusIcon" size={16} variant="outline" />
              Join the Programme
            </Link>
          </div>

          {/* Progress Card Visual */}
          <div className="shrink-0 w-full md:w-72">
            <div className="bg-white/10 border border-white/20 rounded-2xl p-6 backdrop-blur-sm">
              <div className="flex items-center justify-between mb-4">
                <div>
                  <div className="text-white/60 text-xs uppercase tracking-wider mb-0.5">Your Progress</div>
                  <div className="text-white font-bold text-lg">Monday Rounds</div>
                </div>
                <div className="w-12 h-12 rounded-xl gradient-gold flex items-center justify-center">
                  <Icon name="TrophyIcon" size={22} variant="outline" className="text-primary" />
                </div>
              </div>
              <div className="mb-3">
                <div className="flex justify-between text-sm mb-1.5">
                  <span className="text-white/70">7 of 10 rounds</span>
                  <span className="text-accent font-semibold">70%</span>
                </div>
                <div className="h-2.5 bg-white/10 rounded-full overflow-hidden">
                  <div className="h-full rounded-full gradient-gold" style={{ width: '70%' }} />
                </div>
              </div>
              <p className="text-white/60 text-xs">3 more Monday rounds to earn your complimentary breakfast for two!</p>
              <div className="mt-4 pt-4 border-t border-white/10">
                <div className="flex justify-between text-xs text-white/50 mb-2">
                  <span>Rewards Available</span>
                  <span>2 Earned</span>
                </div>
                <div className="space-y-1.5">
                  {['Breakfast for Two', 'Beverage Voucher', 'Cart Hire'].map((r, i) => (
                    <div key={`reward-${r}`} className="flex items-center gap-2">
                      <div className={`w-4 h-4 rounded-full flex items-center justify-center shrink-0 ${i < 2 ? 'bg-accent' : 'bg-white/10'}`}>
                        {i < 2 && <Icon name="CheckIcon" size={10} variant="outline" className="text-primary" />}
                      </div>
                      <span className={`text-xs ${i < 2 ? 'text-white/80 line-through' : 'text-white/50'}`}>{r}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}